// extracted by mini-css-extract-plugin
export default {"brass-chip":"ChipV1_brass-chip__gIBKn"};